export const placeholderChar = '_';
